
import React from 'react';
 import { Button } from 'element-react';
import ReactDOM from 'react-dom';
import { Layout}    from 'element-react';
import FeasComponents from '../render/FeasComponents.js'
 

import KeeVue from '../base/KeeVue.js'
 
 


export default class FsTableCol extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				isShow: false,
				randId: this.getRandString(),
			}
		
}

componentWillMount(){
			var that = this;
			this.registComponent();
		 
		}

		 
		
  render(){
	  
	  
	  var item = this.props.component;
  return( 
  <td  style={{'margin':'-1px',width:(item.cp.width!==''?item.cp.width+'px':''),'textAlign':item.cp.align!==null?item.cp.align:'left'}} >
      <div id={item.id} boxid={item.id} tid={item.id} style={{position: 'relative',width: '100%',height: '100%',border:(item.isSelected==true?'1px solid #f00':(item.isKeeShowBorder?' 1px dashed #97A8BE':'1px solid #fff'))}} >
          <div className={`kee-table-td-title`} style={{'textAlign':item.cp.align!==null?item.cp.align:'left','color': (this.props.componentTable.cp.isHeader!==false?'#333':'#ccc')}} >
            {item.cp.isHidden!==true?item.cp.title:item.cp.title+'[隐藏]'}{item.cp.fixed==true?'固定':''}
          </div>
          <div className={`kee-table-td-body`} >
              <div className={`kee-relative-div`} style={{'minHeight': '100px',background:(item.cp.isHidden!==true?'':'#ccc')}} >
              
  					{item.cp.field}
  					
  				
                  <FeasComponents keePage={this.props.keePage}  components={item.child} debug={this.props.debug} >
                  </FeasComponents>
              </div>
          </div>
		  
		  {
		  	this.props.debug===true&&item.isMoving!==true&&item.isSelected&&<div className={`componentToolBtn`}  >
		  	 <div className={`kee-left`} style={{width:' 100%'}} >
		  		<Button type="primary" size="mimi" title="复制组件"  style={{padding:'3px'}}  onClick={()=>{	this.sendEvent("copyComponent");this.sendEvent("pasteComponent")}} ><i className={`el-icon-document-copy`}></i></Button>
		  		 <Button type="danger"  size="mimi" title="删除组件" style={{padding:'3px'}}  onClick={()=>{this.sendEvent("key.d")}} ><i className={`el-icon-delete`}></i></Button>
		  		 
		  	 </div>
		  	 
		  	</div>
		  }
      </div>
	  
	 
  </td>
  );}
 }
